import React, { useState, useEffect, useMemo } from "react";
import EditItemCategoryModal from "../components/addItemEditModal";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierWithItemModal from "../components/supplierWithItemModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddSupplierWithItem = () => {
  useAuthRedirect();
  const { sCode } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState("");
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////
  const rawPerms = useMemo(
    () =>
      localStorage.getItem("permissions") ||
      localStorage.getItem("userPermissions"),
    []
  );
  const permsLoaded = !!rawPerms;

  //✅ Permission checks (safe even if perms not yet loaded; will be false)
  const canEntry = hasPermission("Supplier With Item", "entry");
  /////////////////////////////////////////////////////////////

  const handleSelectItem = (supplierItem) => {
    setSelectedItems((prevItems) => [...prevItems, supplierItem]);
    setCode(supplierItem.itemmaster_code);
  };

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        Swal.fire({
          title: "Fetching Supplier Details",
          html: `
                  <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                    <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                  </div>
                  <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Category Code...</p>
                `,
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            const style = document.createElement("style");
            style.innerHTML = `
                    @keyframes progressBar {
                      0% { width: 0% }
                      50% { width: 100% }
                      100% { width: 0% }
                    }
                  `;
            document.head.appendChild(style);
          },
        });
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${sCode}`
        );
        const items = response.data.supDetails;
        console.log(response.data.supDetails);

        const storeReqHeader1 = {
          supplierMaster_code: items[0].supplierMaster_code || "N/A",
          supplierMaster_name: items[0].supplierMaster_name || "N/A",
          supplierMaster_addressline1:
            items[0].supplierMaster_addressline1 || "N/A",
          supplierMaster_addressline2:
            items[0].supplierMaster_addressline2 || "N/A",
          supplierMaster_city: items[0].supplierMaster_city || "N/A",
          supplierMaster_pincode: items[0].supplierMaster_pincode || "N/A",
        };
        setSubDetails(storeReqHeader1);
        Swal.close();
        // setData(response.data.supDetails);
      } catch (error) {
        Swal.close();
        console.error("Error fetching Supplier Details. Please try again:", error);
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Error fetching Supplier Details. Please try again",
        });
      }
    };

    {
      canEntry && fetchSupplierDetails();
    }
  }, [sCode]);

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
      Swal.fire("Error", "Please add at least one item", "error");
      return;
    }

    // ✅ 1. Validate required high-level fields
    if (
      !branch ||
      !user ||
      !code ||
      !subDetails.supplierMaster_code ||
      !subDetails.supplierMaster_name
    ) {
      Swal.fire({
        icon: "warning",
        title: "Missing Data",
        text: "Branch, User, Code, and Supplier Info are required.",
      });
      return;
    }

    // ✅ 2. Validate item list
    if (selectedItems.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Items",
        text: "Please select at least one item to submit.",
      });
      return;
    }

    // ✅ 3. Loop through each selected item and validate fields
    for (let i = 0; i < selectedItems.length; i++) {
      const item = selectedItems[i];
      const row = i + 1;

      const price = parseFloat(item.price);
      const discount = parseFloat(item.disc);
      const pf = parseFloat(item.pf);
      const gst = parseFloat(item.gst);
      const quality = parseInt(item.quality, 10);
      const sales = parseInt(item.sales, 10);
      const del = parseInt(item.del, 10);

      // Required fields
      if (!item.itemmaster_code || !item.itemmaster_name) {
        Swal.fire({
          icon: "warning",
          title: `Missing Item Info (Row ${row})`,
          text: "Item code and name are required.",
        });
        return;
      }

      // Numeric validations
      if (isNaN(price) || price < 0) {
        Swal.fire({
          icon: "error",
          title: `Invalid Price (Row ${row})`,
          text: "Price must be a non-negative number.",
        });
        return;
      }

      if (isNaN(discount) || discount < 0 || discount > 100) {
        Swal.fire({
          icon: "error",
          title: `Invalid Discount (Row ${row})`,
          text: "Discount must be a number between 0 and 100.",
        });
        return;
      }

      if (isNaN(pf) || pf < 0 || pf > 100) {
        Swal.fire({
          icon: "error",
          title: `Invalid PF (Row ${row})`,
          text: "PF must be a number between 0 and 100.",
        });
        return;
      }

      if (isNaN(gst) || gst < 0 || gst > 100) {
        Swal.fire({
          icon: "error",
          title: `Invalid GST (Row ${row})`,
          text: "GST must be a number between 0 and 100.",
        });
        return;
      }

      // ✅ FIXED: don't treat 0 (Poor) as "missing"
      if (
        item.quality === "" ||
        item.sales === "" ||
        item.del === "" ||
        Number.isNaN(quality) ||
        Number.isNaN(sales) ||
        Number.isNaN(del)
      ) {
        Swal.fire({
          icon: "warning",
          title: `Missing Promotion Inputs (Row ${row})`,
          text: "Promotion Inputs are required.",
        });
        return;
      }
    }

    // ✅ 4. Create the payload if all validations passed
    const payload = {
      branch: branch,
      user: user,
      sCode: subDetails.supplierMaster_code,
      sName: subDetails.supplierMaster_name,
      code: code,

      items: selectedItems.map((item) => {
        const price = parseFloat(item.price) || 0;
        const discount = parseFloat(item.disc) || 0;
        const pf = parseFloat(item.pf) || 0;
        const gst = parseFloat(item.gst) || 0;

        const discountValue = price * (discount / 100);
        const pfValue = price * (pf / 100);
        const taxValue = price * (gst / 100);
        const totalValue = price + taxValue + pfValue - discountValue;

        const promoteTotal =
          (parseInt(item.quality, 10) || 0) +
          (parseInt(item.sales, 10) || 0) +
          (parseInt(item.del, 10) || 0);

        console.log("Price:", price, "Disc:", discount, "PF:", pf, "GST:", gst);
        console.log("Total Value:", totalValue);

        return {
          itemCode: item.itemmaster_code || "",
          itemName: item.itemmaster_name || "",
          itemUom: item.itemmaster_uom || "",
          price: price,
          gst: gst,
          pf: pf,
          disc: discount,
          value: isNaN(totalValue) ? 0 : Number(totalValue.toFixed(2)),
          promotion: `${item.quality},${item.sales},${item.del}`,
          promoteTot: promoteTotal,
          gstTotal: taxValue,
        };
      }),
    };

    // ✅ You can now send this payload safely with axios or fetch
    // Example:
    // await axios.post("https://rfs2.infraconsoft.net.in/api/submit_items", payload);

    console.log(payload);

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(
        "https://rfs2.infraconsoft.net.in/api/supplierWithItem_insert",
        payload
      );
      Swal.fire("Success", response.data.message, "success");
      setSelectedItems([]);
      navigate("/inventory/supplierMasterView");
    } catch (error) {
      console.error("Error submitting form:", error);
      // 🔥 Display backend message if available
      if (error.response && error.response.data && error.response.data.message) {
        Swal.fire("Error", error.response.data.message, "error");
      } else {
        Swal.fire("Error", "Submission failed. Please try again.", "error");
      }
    }
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Supplier With Item - Add</h2>
            <Link to="/inventory/supplierMasterView">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input
                  type="text"
                  name="scode"
                  value={subDetails.supplierMaster_code}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input
                  type="text"
                  name="sname"
                  value={subDetails.supplierMaster_name}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input
                  type="text"
                  name="address1"
                  value={subDetails.supplierMaster_addressline1}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input
                  type="text"
                  name="address2"
                  value={subDetails.supplierMaster_addressline2}
                  readOnly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input
                  type="text"
                  name="city"
                  value={subDetails.supplierMaster_city}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input
                  type="text"
                  name="pincode"
                  value={subDetails.supplierMaster_pincode}
                  readOnly
                />
              </div>
            </div>

            <div className="flex_buttons">
              <button
                type="button"
                className="button button-add"
                onClick={() => setShowModal(true)}
              >
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Quality</th>
                    <th>After sales Support</th>
                    <th>Delivery</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const discountValue = item.price * (item.disc / 100);
                      const pfValue = item.price * (item.pf / 100);
                      const taxValue = item.price * (item.gst / 100);
                      const totalValue =
                        item.price + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.itemmaster_code}</td>
                          <td>{item.itemmaster_name}</td>
                          <td>{item.itemmaster_uom}</td>
                          <td>
                            <input
                              type="number"
                              value={item.price}
                              onChange={(e) =>
                                handleRowChange(index, "price", e.target.value)
                              }
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={item.gst}
                              onChange={(e) =>
                                handleRowChange(index, "gst", e.target.value)
                              }
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={item.pf}
                              onChange={(e) =>
                                handleRowChange(index, "pf", e.target.value)
                              }
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={item.disc}
                              onChange={(e) =>
                                handleRowChange(index, "disc", e.target.value)
                              }
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <select
                              value={item.quality}
                              onChange={(e) =>
                                handleRowChange(
                                  index,
                                  "quality",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">--Select--</option>
                              <option value="1">Average</option>
                              <option value="3">Excellent</option>
                              <option value="2">Good</option>
                              <option value="0">Poor</option>
                            </select>
                          </td>

                          <td>
                            <select
                              value={item.sales}
                              onChange={(e) =>
                                handleRowChange(index, "sales", e.target.value)
                              }
                            >
                              <option value="">--Select--</option>
                              <option value="1">Average</option>
                              <option value="3">Excellent</option>
                              <option value="2">Good</option>
                              <option value="0">Poor</option>
                            </select>
                          </td>

                          <td>
                            <select
                              value={item.del}
                              onChange={(e) =>
                                handleRowChange(index, "del", e.target.value)
                              }
                            >
                              <option value="">--Select--</option>
                              <option value="1">Average</option>
                              <option value="3">Excellent</option>
                              <option value="2">Good</option>
                              <option value="0">Poor</option>
                            </select>
                          </td>
                          <td className="del">
                            <i
                              className="fa-solid fa-trash-can"
                              onClick={() => handleDeleteRow(index)}
                            ></i>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="10"
                        style={{ color: "green", fontWeight: "bold" }}
                      >
                        Please Add Items...
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      <SupplierWithItemModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        branch={branch}
        onSelectItem={handleSelectItem}
      />
    </div>
  );
};

export default AddSupplierWithItem;
